// extracted by mini-css-extract-plugin
module.exports = {"container":"_2vyQRejtp1l4Mf9mXN0K0Z","title":"_3OgNPZKDa-kLXHkspj4Z72","body":"PpLOnY2pF0ag97omB-nNi","buttons":"_3sqtR6upnRx7oL4BxgPGL3"};